export { default } from './AudioUpload';
